<template>
  <el-dialog
    :title="l('账号信息')"
    v-if="DialogVisible"
    :visible.sync="DialogVisible"
    width="750px"
    class="large-padding-dialog"
    :close-on-click-modal="false"
    :before-close="Hide"
  >
    <EditPassword ref="EditPassword" />

    <el-form
      :model="DialogFormData"
      ref="DialogFormData"
      :rules="dialogRules"
      :class="[{ View: Type == 'View' }]"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-row>
            <el-form-item :label="l('账号')">
              <div
                style="
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <el-input
                  :value="DialogFormData.mobile"
                  disabled
                  style="flex-shrink: 1"
                ></el-input>
                <div
                  class="color-link"
                  style="flex-shrink: 0; margin-left: 20px; cursor: pointer"
                  @click="editPassword"
                >
                  {{ l("修改密码") }}
                </div>
              </div>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item :label="l('用户昵称')" prop="display_name">
              <el-input
                v-model="DialogFormData.display_name"
                :placeholder="l('请输入') + l('用户昵称')"
                :disabled="Type == 'View'"
              ></el-input>
            </el-form-item>
          </el-row>
        </el-col>

        <el-col :span="12" style="text-align: center">
          <ResourceUpLoad
            :label="l('头像')"
            usage="avatar"
            :initResourceUrl.sync="DialogFormData.avatar"
            :disabled="Type == 'View'"
          />
        </el-col>
      </el-row>
      <el-row>
        <el-form-item :label="l('个人简介')" prop="description">
          <el-input
            type="textarea"
            v-model="DialogFormData.description"
            :placeholder="l('将在论坛个人首页展示')"
            :rows="3"
            :disabled="Type == 'View'"
            :maxlength="50"
            :show-word-limit="true"
            :clearable="true"
            resize="none"
          ></el-input>
        </el-form-item>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="Hide">{{ l("取 消") }}</el-button>
      <el-button v-if="Type == 'View'" type="warning" @click="Type = 'Edit'">{{
        l("修 改")
      }}</el-button>
      <el-button
        v-if="Type == 'Create' || Type == 'Edit'"
        type="primary"
        @click="submitForm"
        >{{ l("确 定") }}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";
import EditPassword from "@/views/account/EditPassword.vue";

export default {
  name: "PersonalInfo",
  components: {
    EditPassword,
  },
  mixins: [dialogMixin],
  data() {
    return {
      DialogFormData: {
        id: "",
        mobile: "",
        display_name: "",
        avatar: "",
        description: "",
      },
      dialogRules: {
        display_name: [
          {
            required: true,
            message: this.l("请输入") + this.l("用户昵称"),
            trigger: "blur",
          },
          {
            min: 2,
            max: 16,
            message: this.l("长度在 2 到 16 个字符"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    BeforeShow() {
      this.DialogFormData = {
        id: this.$store.state.session.user.id,
        mobile: this.$store.state.session.user.mobile,
        display_name: this.$store.state.session.user.display_name,
        avatar: this.$store.state.session.user.avatar,
        description: this.$store.state.session.user.description,
      };
    },
    submitForm() {
      this.$refs["DialogFormData"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }

        this.axios
          .put(`/api/account/edit/`, this.DialogFormData)
          .then((data) => {
            this.$emit("submitDialog");
            this.Hide();
          });
      });
    },
    editPassword() {
      this.$refs.EditPassword.Type = "Edit";
      this.$refs.EditPassword.Show();
    },
  },
};
</script>


<style scoped lang="scss">
</style>

